import { render, staticRenderFns } from "./wolt_location_modal.vue?vue&type=template&id=04b28f45&scoped=true&"
import script from "./wolt_location_modal.vue?vue&type=script&lang=js&"
export * from "./wolt_location_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b28f45",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04b28f45')) {
      api.createRecord('04b28f45', component.options)
    } else {
      api.reload('04b28f45', component.options)
    }
    module.hot.accept("./wolt_location_modal.vue?vue&type=template&id=04b28f45&scoped=true&", function () {
      api.rerender('04b28f45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/wolt/location/wolt_location_modal.vue"
export default component.exports